<template>
    <div>
        <!-- user must wait other actions? -->
        <v-alert color="primary" 
                 text 
                 icon="mdi-clock"
                 v-if="isWaiting">
            <strong>Stiamo lavorando per te!</strong> Non appena saranno completate le operazioni in corso potrai procedere con il percorso.
        </v-alert>

        <v-expansion-panels
          v-model="opened"
          :multiple="multiple"
          popout
        >
          <v-expansion-panel
            v-for="(action,i) in pipeline.actions"
            :key="i"
            :disabled="isDisabled(action)">
            
            <v-expansion-panel-header>
                <v-row>
                    <v-col cols="1"
                           align="center">
                        <IconBadge :action="action"
                                   :loading="isLoading(i)"/>
                    </v-col>
                    <v-col align-self="center">
                        <span class="text-h6">
                            {{ action.name }}
                        </span>
                    </v-col>
                </v-row>
            </v-expansion-panel-header>
            
            <v-expansion-panel-content>

                <v-divider/>

                <!-- action description -->
                <div v-if="action.description">
                    <div v-html="action.description"
                         class="py-5"></div>
                    <v-divider class="mb-5"/>
                </div>
                
                <div v-if="isOpen(i)">
                    <keep-alive>
                        <component :is="action.component"
                                 v-bind="action.componentMeta"
                                 :action="action"
                                 @completed="onActionCompleted">
                        </component>
                    </keep-alive>
                </div>

            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-expansion-panels>
        
    </div>
</template>

<script>
import _ from 'lodash'

import utility from '@/mixins/utility'

import Pipeline from '@/models/pipeline'

import IconBadge from '@/components/Action/IconBadge'

export default 
{
   name: 'PipelineExplorer',

   mixins: [ utility ],

   components: 
   {
    IconBadge
   },

   data: () => ({
    opened: []
   }),

   props: {
    pipeline:
    {
        type: Pipeline,
        required: true
    },
    multiple:
    {
        type: Boolean,
        default: false
    }
   },

   computed: 
   {
    // user is waiting other actions?
    isWaiting()
    {
        const actions = this.pipeline.actions, 
              action = _.chain(actions).filter((a)=>!a.isCompleted).first().value()
        
        return action ? !action.canStart : false
    }
   },

   methods:
   {
    onActionCompleted(data)
    {
      this.$emit('completed', data)
    },

    checkHash()
    {
        let hash = window.location.hash

        if( !hash )
            return

        let index = hash.split('-').pop()

        if( isNaN(index) )
            return

        this.open(index)
    },

    isDisabled(action)
    {
        return !action.canStart
    },

    isLoading(index)
    {
        const action = this.pipeline.actions[index],
              prev = this.pipeline.actions[(index-1)],
              isLoading = ( !action.canStart && prev && prev.isCompleted )

        return isLoading
    },

    isOpen(index)
    {   
        const isOpened = this.multiple ? 
                         (this.opened.indexOf(index) >= 0) : 
                         this.opened == index
        
        return isOpened
    },

    open(index)
    {
        if( !this.isOpen(index) )
            if( this.multiple )
                this.opened.push(index)
            else
                this.opened = index
    },

    setCurrentAction(action)
    {
        const index = this.pipeline.actions.findIndex(object => {
          return object.id === action.id
        })

        this.open(index)
    }

   },

   watch:
   {
    multiple(isMultiple)
    {
        this.opened = isMultiple ? [] : null
    },

    pipeline()
    {
        this.checkHash()
    }
   },

   mounted()
   {
    this.checkHash()
   }
}
</script>